import { CadastroAsaasComponent } from './user/cadastro-asaas/cadastro-asaas.component';
import { NgModule } from '@angular/core';
import { AtualizaComponent } from 'src/app/user/atualiza/atualiza.component';
import { CadastroComponent } from 'src/app/user/cadastro/cadastro.component';
import { LoginComponent } from 'src/app/user/login/login.component';
import { ClientLayoutComponent } from 'src/app/layout/client-layout/client-layout.component';
import { Routes, RouterModule } from '@angular/router';
import { EmptyLayoutComponent } from './layout/empty-layout/empty-layout.component';
import { AssociarPacienteLayoutComponent } from './layout/associar-paciente-layout/associar-paciente-layout.component';
import { ServerUrlGuard } from './guards/server-url.guard';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [{
  path: ':client',
  pathMatch: 'full',
  redirectTo: ':client/client'
},
{
  path: ':client',
  canActivate: [ServerUrlGuard],
  component: ClientLayoutComponent,
  children: [{
    path: 'client',
    loadChildren: './client/client.module#ClientModule'
  }]
},
{
  path: ':client',
  component: ClientLayoutComponent,
  children: [{
    path: 'admin',
    loadChildren: './admin/admin.module#AdminModule'
  }]
},
{
  path: ':client',
  component: EmptyLayoutComponent,
  children: [{
    path: 'incorporated',
    loadChildren: './incorporated/incorporated.module#IncorporatedModule'
  }]
},
{
  path: 'login',
  component: LoginComponent
},
{
  path: ':client/client/atualiza',
  component: AtualizaComponent
},
{
  path: ':client/client/cadastro',
  component: CadastroComponent
},
{
  path: ':client/client/cadastro-asaas',
  component: CadastroAsaasComponent
},
{
  path: ':client',
  canActivate: [ServerUrlGuard],
  component: EmptyLayoutComponent,
  children: [
    {
      path: 'associar-paciente/:agendaTipo/:agendamentoIntegracaoId',
      canActivate: [AuthGuard],
      component: AssociarPacienteLayoutComponent
    }
  ]
}
// {
//   path: ':client/associar-paciente/:agendaTipo/:agendamentoIntegracaoId',
//   canActivate: [AuthGuard],
//   component: AssociarPacienteLayoutComponent
// }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }


// { useHash: true }